var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup9117(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3338 17.8856L38.3536 17.8684C38.2302 17.876 38.1068 17.8891 37.9921 17.9063C37.9007 17.9184 37.8099 17.9346 37.7195 17.9528C37.4427 18.0072 37.1709 18.0848 36.9072 18.1847C36.209 18.4468 35.5774 18.8587 35.0572 19.3912C35.0435 19.4953 35.0323 19.6009 35.0227 19.7065C34.9332 20.66 34.9814 21.6214 35.1658 22.5612C35.3339 23.6096 35.7352 24.6074 36.3405 25.4816C36.9458 26.3558 37.7397 27.0843 38.6643 27.6138H38.6841L38.8074 27.5759C37.5123 26.3246 36.7424 24.6309 36.6531 22.8367C36.5639 21.0424 37.162 19.2813 38.3267 17.9088C38.327 17.9006 38.3294 17.8925 38.3338 17.8856Z",
    fill: "url(#paint0_linear_1909_991)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1052 15.2567C32.0844 15.4148 32.0656 15.5745 32.0508 15.7342C31.8128 18.2325 32.3026 20.7463 33.4617 22.975C33.4972 23.0448 33.5358 23.1125 33.5729 23.1812C33.67 23.3611 33.7715 23.5382 33.8775 23.7127C34.8691 25.367 36.2169 26.782 37.8237 27.8559C37.8592 27.8806 37.8927 27.9064 37.9283 27.9281L37.9689 27.9529L37.9826 27.9392L38.0258 27.8973C38.0506 27.8766 38.0765 27.8579 38.1009 27.8397C38.2145 27.7728 38.3363 27.7208 38.4634 27.6851C35.9427 26.1339 35.1832 24.3382 34.834 22.5511C34.6846 21.7833 34.625 21.0008 34.6563 20.2194C34.6563 20.0895 34.6685 19.9591 34.6796 19.8303C34.79 18.4818 35.1724 17.1694 35.804 15.9713C36.4357 14.7733 37.3035 13.7143 38.3557 12.8577C38.2979 12.8516 38.2324 12.8481 38.1806 12.8441C38.0633 12.8355 37.9476 12.8279 37.8303 12.8259C37.2885 12.8127 36.7469 12.8579 36.2149 12.9608C34.6308 13.2617 33.1883 14.0676 32.1052 15.2567Z",
    fill: "url(#paint1_linear_1909_991)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5511 22.5666C30.7721 22.8941 31.0068 23.2119 31.2553 23.5201L31.401 23.7004C32.7421 25.3393 34.4076 26.6862 36.294 27.6571L36.4504 27.737C36.8704 27.9465 37.2979 28.1366 37.7328 28.3074C37.7536 28.2596 37.777 28.2128 37.8028 28.1675L37.7795 28.1528C37.7165 28.1134 37.6561 28.0745 37.5906 28.03C37.4845 27.9613 37.3799 27.8891 37.2764 27.8178H37.2687C36.0487 26.9703 34.9824 25.9225 34.1155 24.7191C33.9632 24.5079 33.8185 24.2896 33.6764 24.0673C33.4733 23.7459 33.2819 23.4145 33.1027 23.0709C32.0181 20.98 31.5209 18.6365 31.6634 16.2878C31.6756 16.1023 31.6893 15.9194 31.7076 15.732C31.9342 13.5402 32.7088 11.4397 33.9607 9.62238C33.7363 9.66482 33.5128 9.71534 33.29 9.77395C31.1172 10.3476 29.209 11.6483 27.8863 13.4573C27.7891 16.6973 28.7222 19.8851 30.5526 22.5661L30.5511 22.5666Z",
    fill: "url(#paint2_linear_1909_991)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4115 25.1619C31.7291 26.9956 34.4707 28.2232 37.3867 28.7331L37.5948 28.7665L37.6096 28.6927C37.6157 28.6695 37.6207 28.6462 37.6268 28.623C35.2306 27.7389 33.0922 26.277 31.4032 24.3682C31.2678 24.2183 31.1366 24.0649 31.0097 23.9079C29.231 21.7393 28.0754 19.1318 27.6656 16.3623C27.2559 13.5927 27.6073 10.7644 28.6825 8.17761C28.4358 8.28069 28.1892 8.39319 27.9428 8.51513C25.5381 9.72796 23.6355 11.7399 22.5649 14.2023C23.18 17.2866 24.5837 20.1609 26.6406 22.5477C27.4715 23.5116 28.4 24.3877 29.4115 25.1619Z",
    fill: "url(#paint3_linear_1909_991)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5416 26.3627C25.3135 26.8574 26.1177 27.3001 26.949 27.688C30.0811 29.1544 33.5414 29.7887 36.993 29.5292C37.1854 29.5145 37.3778 29.4958 37.5702 29.4786C37.5702 29.4236 37.5641 29.368 37.5606 29.3129V29.1057C37.1101 29.0384 36.6613 28.9565 36.2142 28.8602C33.5999 28.2789 31.1454 27.1344 29.0234 25.5073C28.4495 25.0691 27.9018 24.5979 27.3831 24.0961C24.8215 21.6171 23.0427 18.4478 22.2651 14.9771C21.7478 12.6862 21.6749 10.3181 22.0504 8C21.7925 8.18644 21.5397 8.38299 21.2944 8.58913C18.8507 10.6349 17.2048 13.4685 16.6431 16.597C18.1513 20.6134 20.9213 24.0383 24.5416 26.3627Z",
    fill: "url(#paint4_linear_1909_991)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0183 31.1313C25.487 31.4424 26.9844 31.5987 28.4859 31.5977C31.2751 31.6011 34.0372 31.0538 36.6124 29.9874C36.0756 30.0268 35.5371 30.0437 34.997 30.038C32.0969 30.0169 29.236 29.3699 26.6116 28.1417L26.4537 28.0654C21.9352 25.918 18.3869 22.1664 16.5062 17.5479C15.6708 15.4992 15.1796 13.3278 15.0522 11.1205V11.0947C14.8202 11.3549 14.5953 11.6222 14.3836 11.8996C13.1735 13.4677 12.2903 15.2605 11.7857 17.1729C11.2811 19.0852 11.1653 21.0786 11.4451 23.0361C14.4981 27.1764 18.9722 30.0571 24.0183 31.1313Z",
    fill: "url(#paint5_linear_1909_991)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4876 32.3387C38.1733 32.3387 37.9672 32.1336 37.8708 31.7324C37.7733 31.3054 37.7103 30.8633 37.6621 30.4879C37.66 30.4496 37.6554 30.4115 37.6484 30.3737L37.6337 30.2424L37.6154 30.0681L37.6042 29.9574C34.7048 31.3742 31.5168 32.1088 28.2867 32.1043C27.6183 32.1043 26.9583 32.0739 26.3068 32.0133C20.9844 31.5158 16.0488 29.0309 12.4928 25.0584C12.1882 24.7172 11.8962 24.3662 11.617 24.0054C11.6175 24.0108 11.6175 24.0162 11.617 24.0216C10.8689 23.0725 10.2043 22.0611 9.63047 20.9986C9.52588 21.3483 9.44567 21.7156 9.36647 22.0738C8.54349 25.7918 9.11739 29.681 10.9797 33.0065C12.8421 36.332 15.8638 38.8634 19.474 40.1224C23.0841 41.3814 27.0326 41.2807 30.5733 39.8393C34.1139 38.398 37.0014 35.7159 38.6902 32.2998C38.6261 32.3223 38.5586 32.3339 38.4906 32.3341L38.4876 32.3387Z",
    fill: "url(#paint6_linear_1909_991)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4031 35.0947C33.386 35.0949 32.3916 34.7949 31.5459 34.2327C30.7001 33.6704 30.0408 32.8712 29.6514 31.936C29.2621 31.0008 29.1601 29.9718 29.3585 28.9789C29.5568 27.9861 30.0466 27.0741 30.7657 26.3583C31.4849 25.6425 32.4012 25.155 33.3988 24.9575C34.3964 24.76 35.4304 24.8614 36.3701 25.2488C37.3097 25.6362 38.1129 26.2922 38.6779 27.1339C39.243 27.9756 39.5445 28.9652 39.5444 29.9774C39.5441 31.3344 39.0024 32.6358 38.0383 33.5954C37.0742 34.555 35.7666 35.0943 34.4031 35.0947Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4054 34.6599C37.0043 34.6599 39.1111 32.5631 39.1111 29.9766C39.1111 27.3901 37.0043 25.2933 34.4054 25.2933C31.8065 25.2933 29.6997 27.3901 29.6997 29.9766C29.6997 32.5631 31.8065 34.6599 34.4054 34.6599Z",
    fill: "#901F5D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9757 29.6507L33.6301 27.1112C33.5684 27.0644 33.4947 27.0356 33.4175 27.0281C33.3402 27.0207 33.2624 27.0349 33.1928 27.0691C33.1232 27.1032 33.0645 27.1561 33.0235 27.2217C32.9824 27.2872 32.9606 27.3629 32.9604 27.4402V32.5201C32.9606 32.5973 32.9824 32.673 33.0235 32.7386C33.0645 32.8041 33.1232 32.857 33.1928 32.8912C33.2624 32.9254 33.3402 32.9395 33.4175 32.9321C33.4947 32.9246 33.5684 32.8958 33.6301 32.849L36.9757 30.3095C37.0262 30.2708 37.067 30.221 37.0951 30.1641C37.1233 30.1072 37.1379 30.0446 37.1379 29.9811C37.1379 29.9177 37.1233 29.8551 37.0951 29.7982C37.067 29.7412 37.0262 29.6915 36.9757 29.6527V29.6507Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1909_991",
    x1: 37.8618,
    y1: 15.3735,
    x2: 32.5446,
    y2: 22.5109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352",
    stopOpacity: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#DC3C54",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#B22C58",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#98225A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F1E5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1909_991",
    x1: 35.1048,
    y1: 11.7646,
    x2: 36.82,
    y2: 26.8865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352",
    stopOpacity: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#DC3C54",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#B22C58",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#98225A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F1E5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1909_991",
    x1: 33.7144,
    y1: 7.51097,
    x2: 29.1724,
    y2: 27.1147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352",
    stopOpacity: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#DC3C54",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#B22C58",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#98225A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F1E5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1909_991",
    x1: 29.3729,
    y1: 9.72178,
    x2: 31.6944,
    y2: 29.7334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352",
    stopOpacity: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#DC3C54",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#B22C58",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#98225A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F1E5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1909_991",
    x1: 22.7956,
    y1: 11.8855,
    x2: 31.5784,
    y2: 32.9584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352",
    stopOpacity: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#DC3C54",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#B22C58",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#98225A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F1E5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1909_991",
    x1: 19.1444,
    y1: 17.8197,
    x2: 25.3216,
    y2: 34.5564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352",
    stopOpacity: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#DC3C54",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#B22C58",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#98225A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F1E5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1909_991",
    x1: 16.7788,
    y1: 21.2386,
    x2: 23.4517,
    y2: 41.4753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352",
    stopOpacity: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#DC3C54",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#B22C58",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#98225A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F1E5B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup9117);
export default __webpack_public_path__ + "static/media/Group 9117.600237ee.svg";
export { ForwardRef as ReactComponent };